import type { iFlowType } from '@/types/index';
import blueimp from 'blueimp-md5';
import mitt from 'mitt'

export const ev = mitt()

// @ts-ignore
ev.once = (event, fn) => {
  const f = () => {
    fn()
    ev.off(event, f)
  }

  ev.on(event, f)
}

export const ACTIVITY_TYPES = {
  AgentReward: 'AgentReward',
  AgentReturn: 'AgentReturn',
  Redeem: 'Redeem',
  NewbieProtection: 'NewbieProtection',
  RedEnvelopeRain: 'RedEnvelopeRain',
  Remain: 'Remain',
  VipReward: 'VipReward',
  LevelReward: 'LevelReward',
  Relief: 'Relief',
  WeeklyCompensation: 'WeeklyCompensation',
  PinduoduoReward: 'PinduoduoReward',
  Turntable: 'Turntable',
  CustomActivity: 'CustomActivity',
  RealtimeRebate: 'RealtimeRebate',
  TreasureBox: 'TreasureBox',
  MysteryBonus: 'MysteryBonus',
  DepositReward: 'DepositReward', // 充值奖励
  DepositBonus: 'DepositBonus', // 充值赠送
  MemberAward: 'MemberAward',
}

export const SYSTEM_ACTIVITY_LIST = [
  // 代理中心
  ACTIVITY_TYPES.AgentReward,
  // VIP 奖励
  ACTIVITY_TYPES.VipReward,
  // 等级奖励
  ACTIVITY_TYPES.LevelReward,
  // 代理返现
  ACTIVITY_TYPES.AgentReturn,
  // 留存奖励
  ACTIVITY_TYPES.Remain,
  // 兑换码
  ACTIVITY_TYPES.Redeem,
  // 拼多多
  ACTIVITY_TYPES.PinduoduoReward
];

// export const ACTIVITY_NAMES = {
//   promocao: 'Promoção',
//   All: 'Tudo'
// };
//
interface iActivityData {
  linkName: string;
  flowType: iFlowType;
  name: string;
}

export const ACTIVITY_DATA: Record<typeof ACTIVITY_TYPES[keyof typeof ACTIVITY_TYPES], iActivityData> = {
  // 代理返现
  AgentReturn: {
    linkName: 'cashback',
    flowType: 'AgentRebate',
    name: 'Cashback'
  },
  // 红包雨
  RedEnvelopeRain: {
    linkName: 'redpackage',
    flowType: 'RedEnvelopeRainReward',
    name: 'Chuva de Dinheiro'
  },
  // 等级奖励
  LevelReward: {
    linkName: 'level',
    flowType: 'LevelReward',
    name: 'Nivel'
  },
  // VIP 奖励
  VipReward: {
    linkName: 'vip',
    flowType: 'VipReward',
    name: 'VIP'
  },
  // 充值活动, 新的，老版本不存在
  DepositReward: {
    linkName: 'bonus',
    flowType: 'DepositReward',
    name: 'Depósito Bónus'
  },
  // 充值赠送
  DepositBonus: {
    linkName: 'deposito',
    flowType: 'DepositBonus',
    name: 'Depósito'
  },
  // 留存奖励
  Remain: {
    linkName: 'retention',
    flowType: 'RetainReward',
    name: 'Diário'
  },
  // 代理中心
  AgentReward: {
    linkName: 'agentcenter',
    flowType: 'AgentCommission',
    name: 'Comissão'
  },
  // 拼多多
  PinduoduoReward: {
    linkName: 'cashwheel',
    flowType: 'PddReward',
    name: 'Magnata'
  },
  // 兑换码
  Redeem: {
    linkName: 'giftcode',
    flowType: 'RedeemReward',
    name: 'Código'
  },
  // 救济金
  Relief: {
    linkName: 'jiujijin',
    flowType: 'AidReward',
    name: 'Auxílio'
  },
  // 超级大转盘
  Turntable: {
    linkName: 'lottery',
    flowType: 'SuperWheelReward',
    name: 'Roda'
  },
  // 实时返水
  RealtimeRebate: {
    linkName: 'rebate',
    flowType: 'UserRebateReward',
    name: 'Rebate'
  },
  // 神秘奖励
  MysteryBonus: {
    linkName: 'secretbonus',
    flowType: 'MysteryBonusReward',
    name: 'MysteryBonus'
  },
  // 宝箱活动
  TreasureBox: {
    linkName: 'treasurebox',
    flowType: 'TreasureBoxReward',
    name: 'Baú'
  },
  // 自定义活动
  CustomActivity: {
    linkName: 'custom',
    flowType: 'CustomActivity',
    name: 'Custom'
  }
};

// export const All_ACTIVITY_DATA = Object.fromEntries(Object.entries(ACTIVITY_DATA).map(([key, value]) => {
//   return [key, {
//     ...value,
//     link: `/${SYSTEM_ACTIVITY_LIST.includes(key) ? 'promocao/' + value.linkName : value.linkName}`,
//     isSystem: SYSTEM_ACTIVITY_LIST.includes(key),
//     name: ACTIVITY_NAMES[key] || ''
//   }]
// }))

export const USERINFO_KEY = blueimp('userinfo')
export const FINGER_PRINT_KEY = blueimp('yz_finger_print_key')
export const SALT_KEY = '$2b$10$e35OHWgqAQ1VqxELC854le'
export const CUSTOM_PROTOCOL = 'web+' + (location.hostname.replace(/[^a-z]/g, "") || 'jogos')

export const DETECT_TIME = 10000
export const INSTALL_TIME = 25000

export const PARAMS_AK = 'i7pXJ7C0GRAFhqG'

export const INSTALLCONFIG_TIME = 'showGuideInstall'

export const HOST = 'https://c.bg52w.com'
export const URL_PREFIX = HOST + '/public/static'
export const THEME_A = URL_PREFIX + '/a'
export const THEME_B = URL_PREFIX + '/b'
